import { toTitleCase } from 'common/utils';
import CustomButton from 'components/buttons/CustomButton/CustomButton';
import CustomDialog from 'components/dialogs/CustomDialog'
import { useAuth } from 'context/AuthContext';
import { useProfileContext } from 'context/ProfileContext';
import { useDeleteEducation, useDeleteExperience } from 'hooks/useUsers';
import React, { useState } from 'react'
import { snackbarService } from 'services/snackbarService';

interface Props {
  open: boolean;
  setOpen: (value: boolean) => void;
  userId: number,
  educationId: number,
}

export default function DeleteEducationDialog({
  open,
  setOpen,
  userId,
  educationId,
}: Props) {
  const { refetch } = useProfileContext();

  const { mutate: deleteMutation, isLoading } = useDeleteEducation(
    (data: any) => {
      setOpen(false);
      snackbarService.showSnackbar(`Education has been deleted successfully`, 'success');
      refetch();
    },
    (error: any) => {
      console.log('error', error);
    },
  )

  const handleDelete = () => {
    deleteMutation({
      userId: userId,
      educationId,
    });
  };


  return (
    <CustomDialog
      open={open}
      title={`Delete Education`}
      message={`Are you sure you want to delete this education?`}
      buttons={[
        <CustomButton
          key='cancel'
          text='Cancel'
          variant='outlined'
          onClick={() => setOpen(false)}
          disabled={isLoading}
        />,
        <CustomButton
          key='delete'
          text='Delete'
          color='error'
          onClick={handleDelete}
          loading={isLoading}
        />
      ]}
    />
  )
}
